'use client';

import { Skeleton } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useEffect, useState, type ComponentProps } from 'react';
import { getEducationalStepImage } from '../../utils/images';

type EducationalTutorialImageProps = ComponentProps<'div'> & {
  stepKey: string;
};

function EducationalTutorialImage({ stepKey, className, ...props }: EducationalTutorialImageProps) {
  const t = useTranslations('global_dialogs.educational');
  const imageUrl = getEducationalStepImage(stepKey);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsLoaded(false);
  }, [stepKey]);

  return (
    <div className={className} {...props}>
      <div className="relative w-full h-46">
        {!isLoaded && <Skeleton className="absolute inset-0 rounded-b-none rounded-t-lg" data-testid="educational-tutorial-image-skeleton" />}
        <Image
          key={stepKey}
          src={imageUrl}
          alt={t(`${stepKey}.image_alt`) || ''}
          className="object-cover"
          priority
          fill
          unoptimized
          sizes="(max-width: 416px) calc(100vw - 2rem), 384px"
          onLoad={() => setIsLoaded(true)}
        />
      </div>
    </div>
  );
}

export { EducationalTutorialImage };
